// components/ProcessStepsSection.js
import React from "react";
import { motion } from "framer-motion";

const steps = [
    {
        title: "Initial Consultation",
        description: "We get to know your goals, explain our process, and set expectations from the beginning."
      },
      {
        title: "Strategy & Planning",
        description: "We build a tailored investment strategy based on your profile, budget, and goals."
      },
      {
        title: "Research & Shortlisting",
        description: "We run suburb research and shortlist properties that match your brief and yield potential."
      },
      {
        title: "Due Diligence",
        description: "We conduct data-based due diligence on selected properties including overlays, zoning, and comparable sales."
      },
      {
        title: "Physical Inspections",
        description: "We coordinate with sales agents for physical inspections and provide visual feedback to you."
      },
      {
        title: "Negotiation",
        description: "We negotiate with the agent to secure the best price and terms for your property."
      },
      {
        title: "Build & Pest + Reports",
        description: "We assist in booking and reviewing third-party reports including building and pest inspections."
      },
      {
        title: "Liaising with Broker & Conveyancer",
        description: "We stay in touch with your mortgage broker and conveyancer to ensure a smooth transaction."
      },
      {
        title: "Settlement & Next Steps",
        description: "We assist through to settlement and guide you on what’s next—property management, insurance, etc."
      },
      {
        title: "Lifetime Relationship",
        description: "We invest in relationships, not just real estate."
      }
];

const ProcessStepsSection = () => {
  return (
    <section className="bg-white pt-8 pb-20 px-6">

      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl font-bold text-center text-[#003366] mb-16">
          Our Process
        </h2>
        <div className="relative border-l-4 border-[#fbb40b] ml-4">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className={`relative mb-12 pl-10 pr-6 ${index % 2 === 0 ? "lg:ml-0 lg:mr-auto" : "lg:ml-auto lg:mr-0"} max-w-xl`}
            >
              <div className="absolute -left-6 top-1.5 w-10 h-10 rounded-full bg-[#003366] text-white font-bold flex items-center justify-center border-4 border-white shadow-md">
                {index + 1}
              </div>
              <h3 className="text-xl font-semibold text-[#003366] mb-2">
                {step.title}
              </h3>
              <p className="text-gray-700 text-sm leading-relaxed">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessStepsSection;